import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared header/footer shell for all DentalStaff jobseeker pages.
 * Keeps brand consistency without re-importing nav code in every page.
 */
export function JobsShell({ children, showSigninLink = true, showSignupLink = true }) {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="jobs-shell">
      <div className="h-1.5 bg-gradient-to-r from-pink-500 via-purple-500 via-blue-500 via-cyan-400 to-emerald-400" />
      <nav className="bg-gradient-to-r from-indigo-700 via-blue-700 to-cyan-600 shadow-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/jobs" className="flex items-center gap-3 group">
            <div className="w-10 h-10 rounded-xl bg-white shadow flex items-center justify-center group-hover:rotate-6 transition-transform">
              <svg viewBox="0 0 32 32" className="w-6 h-6" aria-hidden="true">
                <defs>
                  <linearGradient id="toothG2" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#06b6d4" />
                    <stop offset="100%" stopColor="#2563eb" />
                  </linearGradient>
                </defs>
                <path
                  d="M16 3c-4 0-7 2-9 2s-3 2-3 5c0 4 2 7 3 12 .6 3 1.8 7 4 7 1.5 0 2-2 2.5-4.5S14.5 21 16 21s2 1 2.5 3.5S20 29 21.5 29c2.2 0 3.4-4 4-7 1-5 3-8 3-12 0-3-1-5-3-5s-5-2-9-2z"
                  fill="url(#toothG2)"
                />
              </svg>
            </div>
            <div className="leading-tight">
              <div className="text-white font-extrabold text-lg">DentalStaff</div>
              <div className="text-cyan-200 text-[10px] uppercase tracking-widest font-semibold">
                by PractCom
              </div>
            </div>
          </Link>
          <div className="flex items-center gap-2">
            {showSigninLink && (
              <Link
                to="/jobs/login"
                data-testid="shell-signin-link"
                className="px-4 py-2 text-sm font-semibold text-white/90 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
              >
                Sign In
              </Link>
            )}
            {showSignupLink && (
              <Link
                to="/jobs/signup"
                data-testid="shell-signup-link"
                className="px-4 py-2 text-sm font-bold bg-white text-blue-700 rounded-lg hover:bg-cyan-50 transition-colors shadow-sm"
              >
                Create Free Account
              </Link>
            )}
          </div>
        </div>
      </nav>

      <main className="flex-1">{children}</main>

      <footer className="bg-slate-900 text-slate-400 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-sm flex flex-wrap items-center justify-between gap-3">
          <p>© {new Date().getFullYear()} The Oncall Bot LLC · DentalStaff by PractCom</p>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <a href="mailto:admin@practcom.com" className="hover:text-white">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
